// Style
import style from "./term-button.module.scss";

// Icons
import Info from "/public/icons/info.svg";

// function clickHandler(e) {
//   e.preventDefault();
//   e.stopPropagation();
//   const btn = e.currentTarget;
//   btn.ariaExpanded = btn.ariaExpanded === "false" ? true : false;
// }

export default function TermButton({ term }) {
  const attributes = {
    "data-term": term.toLowerCase(),
    "aria-label": "Open popup to read a brief description of " + term,
    "aria-expanded": false,
    "aria-owns": "term-modal",
  };

  return (
    <button
      className={"termBtn " + style.termBtn}
      {...attributes}
      // onClick={(e) => clickHandler(e)}
    >
      <Info color="#1fb4ff" />
    </button>
  );
}
